/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_StatsInputs */

const tr_landing_community_mock_stats = /** @type {(inputs: Landing_Community_Mock_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 847 satıcı · 124 çevrimiçi`)
};

const en_landing_community_mock_stats = /** @type {(inputs: Landing_Community_Mock_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 847 sellers · 124 online`)
};

const de_landing_community_mock_stats = /** @type {(inputs: Landing_Community_Mock_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 847 Verkäufer · 124 online`)
};

const ru_landing_community_mock_stats = /** @type {(inputs: Landing_Community_Mock_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 847 продавцов · 124 онлайн`)
};

/**
* | output |
* | --- |
* | "2 847 sellers · 124 online" |
*
* @param {Landing_Community_Mock_StatsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_stats = /** @type {((inputs?: Landing_Community_Mock_StatsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_StatsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_stats(inputs)
	if (locale === "de") return de_landing_community_mock_stats(inputs)
	if (locale === "ru") return ru_landing_community_mock_stats(inputs)
	return tr_landing_community_mock_stats(inputs)
});